<template>
  <BaseNoticeItem>
    <template #head>
      <strong>
        {{ $t(title) }}
      </strong>
    </template>
    <template #body>
      <div>
        {{ $t(description) }}
      </div>
    </template>
  </BaseNoticeItem>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'
import { $t } from '@/composables/translation'

interface Props {
  complianceData?: {
    status?: string
    status_title?: string
    status_description_worker?: string
  }
}

const props = withDefaults(defineProps<Props>(), {
  complianceData: undefined,
})

const title = computed(() => {
  if (props.complianceData?.status_title) {
    return props.complianceData.status_title
  }
  return 'Background Checks In Progress'
})

const description = computed(() => {
  if (props.complianceData?.status_description_worker) {
    return props.complianceData.status_description_worker
  }
  return 'Your background checks have been initiated. You will be notified once they are complete and the contract is ready for signature. Your start date may be adjusted based on the completion of the background checks.'
})
</script>
